import { wafFetch } from "./awsWafIntegration";
import { ConnecteeSubmission } from "../types/connecteeSubmission";

export async function fetchConnecteeSubmission(accessToken: string): Promise<ConnecteeSubmission> {
  const url = `${import.meta.env.VITE_UNYTE_WEBHOOKS_URL}/connectee-submission`;
  const response = await wafFetch(url, {
    method: "GET",
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || `Failed to fetch submission (${response.status})`);
  }

  return response.json();
}
